import { useEffect, useState } from "react";
import { imageKeyMappings } from "../../../assets/images/imageKeyMappings";
import PubSub from "pubsub-js";
import { APILOG } from "../../../config/services/Analytics";
import { eventTrack } from "../../../config/utils/GaTags";

function TncViewer({ tncUrl }) {
  const [htmlContent, setHtmlContent] = useState("");

  function closeTncPopup() {
    PubSub.publish("tncClose", {});
  }

  useEffect(() => {
    APILOG("tnc_popup", "pageload");
    eventTrack("pageload", "tnc_popup");
    APILOG("first_visit_page", "read_tnc");
    eventTrack("read_tnc", "first_visit_page");

    // Fetch the raw HTML content from the URL
    fetch(tncUrl)
      .then((response) => response.text())
      .then((data) => {
        setHtmlContent(data); // Set the raw HTML content to state
      })
      .catch((error) => {
        console.error("Error fetching the T&C content:", error);
      });
  }, [tncUrl]);

  return (
    <div className="tnc-viewer">
      <div className="bg" onClick={closeTncPopup}></div>
      <div className="tnc-block">
        <div className="header">
          <div className="tnc-text">Terms & Conditions</div>
          <div className="cross-icon" onClick={closeTncPopup}>
            <img src={imageKeyMappings?.closeTncPopup} alt="Close T&C" />
          </div>
        </div>
        {/* Check if we have HTML content */}
        {htmlContent ? (
          <iframe
            className="iFrame"
            frameBorder="0"
            style={{  padding: '1.5rem', height:"90%" }}
            srcDoc={htmlContent} 
          ></iframe>
        ) : (
          <div></div> 
        )}
      </div>
    </div>
  );
}

export default TncViewer;
